export default __webpack_public_path__ + "static/media/transfer-receive-step2-option1.1ce49eff.png";